"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AudioInputChooser = require("./AudioInputChooser");
Object.keys(_AudioInputChooser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioInputChooser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioInputChooser[key];
    }
  });
});